(function(){
  document.querySelectorAll('[data-op]').forEach(function(root){
    var track=root.querySelector('[data-op-track]'),thumbs=root.querySelectorAll('[data-op-thumb]'),dots=root.querySelectorAll('.op__dots span');
    function goTo(id){var s=root.querySelector('[data-media-id="'+id+'"]');if(s&&track)track.scrollTo({left:s.offsetLeft-track.offsetLeft,behavior:'smooth'});}
    thumbs.forEach(function(t){t.addEventListener('click',function(){goTo(t.getAttribute('data-op-thumb'));});});
    if(track){var raf;track.addEventListener('scroll',function(){cancelAnimationFrame(raf);raf=requestAnimationFrame(function(){
      var i=Math.round(track.scrollLeft/track.clientWidth);
      thumbs.forEach(function(t,k){t.classList.toggle('is-active',k===i);});dots.forEach(function(d,k){d.classList.toggle('is-active',k===i);});
    });},{passive:true});}
    var vj=root.querySelector('[data-op-variants]');if(!vj)return;
    var variants=JSON.parse(vj.textContent),idIn=root.querySelector('[data-op-id]'),atc=root.querySelector('[data-op-atc]'),lbl=root.querySelector('[data-op-atc-label]'),
        now=root.querySelector('[data-op-now]'),was=root.querySelector('[data-op-was]'),save=root.querySelector('[data-op-save]');
    function fmt(c){return (c/100).toLocaleString('en-US',{style:'currency',currency:'USD'});}
    root.addEventListener('change',function(e){
      if(!e.target.matches('[data-op-opt]'))return;
      var sel=[];root.querySelectorAll('[data-op-opt]:checked').forEach(function(i){sel[+i.getAttribute('data-op-opt')]=i.value;});
      var l=root.querySelector('[data-op-label="'+e.target.getAttribute('data-op-opt')+'"]');if(l)l.textContent=e.target.value;
      var v=variants.find(function(x){return x.options.every(function(o,k){return o===sel[k];});});
      if(!v){atc.disabled=true;lbl.textContent='Unavailable';return;}
      idIn.value=v.id;atc.disabled=!v.available;lbl.textContent=v.available?'Add to cart':'Sold out';
      now.textContent=fmt(v.price);
      var on=v.compare_at_price&&v.compare_at_price>v.price;was.hidden=!on;save.hidden=!on;
      if(on){was.textContent=fmt(v.compare_at_price);save.textContent='Save '+fmt(v.compare_at_price-v.price).replace('.00','');}
      if(v.featured_media)goTo(v.featured_media.id);
      var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u);
    });
  });
})();
